import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const poEdit = createAsyncThunk("poEdit", async (values, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`channel/${values.channel}/po/${values.id}`, { ...values.values });
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const RewardsPOEditSlice = createSlice({
	name: "RewardsPOEditSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPOEditState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(poEdit.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(poEdit.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(poEdit.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPOEditState } = RewardsPOEditSlice.actions;
export default RewardsPOEditSlice.reducer;
